<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-x>
    <template v-slot:activator="{ onMenu }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip }">
          <v-btn icon class="ml-1" v-on="{ ...onMenu, ...onTooltip }">
            <v-icon @click="menu = true">
              add
            </v-icon>
          </v-btn>
        </template>
        <span>Створити тег</span>
      </v-tooltip>
    </template>
    <v-card min-width="260px">
      <v-card-text>
        <v-text-field
          v-model="item"
          :label="`Створити ${label}`"
          :hide-details="hideDetails"
          :placeholder="placeholder"
          :error-messages="errorMessages"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          :loading="loading"
          :disabled="!item"
          @click="
            menu = false;
            $emit('handler', item);
            item = '';
          "
        >
          ОК
        </v-btn>
        <v-btn
          text
          @click="
            menu = false;
            item = '';
            $emit('handler', '');
          "
        >
          Відміна
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    item: "",
    menu: false,
  }),
};
</script>
